import { CRUDVerbs } from '../lib/constants';

export default function getCRUDVerbName(verb) {
  switch (verb) {
    case CRUDVerbs.CREATE:
      return 'CREATE';

    case CRUDVerbs.READ:
      return 'READ';

    case CRUDVerbs.UPDATE:
      return 'UPDATE';

    case CRUDVerbs.DELETE:
      return 'DELETE';

    default:
      return null;
  }
}
